/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },

    /*
    updatefound () {
      console.log('New content is downloading.')
    },
    */

    updatefound () {
      console.log('New content is downloading.')
        caches.keys().then(function(names) {
          for (let name of names)
              caches.delete(name);
      });
    },
    
    /*
    updated () {
      console.log('New content is available; please refresh.')
    },
    */

    updated(registration) {
      console.log('New content is available; updating now.');
    
      // Unregister the old service worker
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        
        // Listen for when the new SW is activated, then reload
        registration.waiting.addEventListener('statechange', (event) => {
          if (event.target.state === 'activated') {
            window.location.reload();
          }
        });
      }
    },

    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
